<template>
<div>

<div class="modal-content border border-success">
<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA SCONTRINO FISCALE</strong>
  </h4>  
</div>
<!--
<div class="modal-body border border-success">
  <span style="color:red" v-if="msg.title"> {{ msg.body }}</span>
  
</div>
-->

<div class="modal-footer">
    <button @click="$emit('close')" type="button" class="btn btn-secondary ">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
    </button>

    <button  @click="getData()" :disabled="bt_spinner==true" type="button" class="btn btn-primary ">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA 
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button>    
</div>

</div>

</div>

</template>

<script>




import getSaleData       from '@/components/rt/mixins/getSaleData'
import fmt               from '@/components/mixins/fmt'

  export default {

  props : ['data'],
  mixins : [getSaleData,fmt],
     
    data () {
      return {
          
          newLine  : '\r\n',
          bt_spinner : false,
         
          items    : [],
          payments : []                           
      }
    },

      
    methods: 
    {
    getData()
      { 
        
        this.bt_spinner = true
        const data      = this.getSaleData(this.data.saleId)
        data.then((res) => { 
            console.log('data',res);
            this.items     = res[0]
            this.payments  = res[1]
            this.getTxtFile()
            
          }).catch((err) => { 
            this.items     = []
            this.payments  = []
            this.bt_spinner = false
            console.log(err);
            });
     },
     getTxtFile() 
     {
                          
         let txtFile                = "data:text/csv;charset=utf-8," 
         let data                   =  ''
         let total_discount         = ''
         let round_total            = ''

            if(this.data.lottery)
            {
                
              data = '"' + this.data.lottery + '"'  + '@38F'  
              txtFile += data + this.newLine;  
               

            } 
            
            this.items.forEach(item => {

                total_discount = this.fmt1(item.total_discount).replace('.',"").replace(',','')                          
                round_total    = this.fmt1(item.round_total).replace('.',"").replace(',','')                          
                const price    = this.fmt1(item.price).replace('.',"").replace(',','')                          
                if(Number(item.discount) > 0)
                {
                  
                  data    = '"' + item.barcode + ' ' + item.category + '"' + price + 'H1R'  
                  txtFile += data + this.newLine;                  
                  data    =  + item.discount + '*1M'  
                  
                }
                else
                {
                  data = '"' + item.barcode + ' ' + item.category + '"' + price + 'H1R'                     
                }
                txtFile += data + this.newLine;
             
            });
           
                        
            data = '40F'  
            txtFile += data + this.newLine;
            
            if(Number(total_discount))
            {
              data    = '=' + total_discount + 'H4M'   
              txtFile += data + this.newLine;  
            }

            if(round_total)
            {
              data =  '=' + round_total + 'H8M'   
              txtFile += data + this.newLine;  
            }

            const totalElec =   this.payments.filter(item => item.typeId == 'ELEC' || item.typeId == 'PAGO' || item.typeId == 'SCAL') 
            this.payments.forEach(item=>{
                if(item.typeId == 'CASH')                
                {
                    data   = this.fmt1(item.amount).replace('.',"").replace(',','')  + 'H1T';
                    txtFile += data + this.newLine;            
                }                
                if(item.typeId == 'CRED')
                {
                    data    = this.fmt1(item.amount).replace('.',"").replace(',','')  + 'H5T';
                    txtFile += data + this.newLine;
                }

            })

            let total = 0
            totalElec.forEach(item=>{
                total += item.amount
            })  
            if(total > 0)
            {

              data       = this.fmt1(total).replace('.',"").replace(',','')  + 'H3T';
              txtFile    += data  + this.newLine;
            }

              data       = '41F'
              txtFile    += data
              txtFile    += '"' +  'S' + this.data.saleId + '"3B' +  this.newLine
              data       = '42F'
              txtFile    += data
              
                        
            const encodedUri = encodeURI(txtFile);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "scontrino.txt");      
            link.click()
            this.$emit('close')
   
        
          }
    }
    
  }
</script>
<style scoped>
 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-footer {  
  justify-content: space-between;  
}
.modal-content
{
  width:  500px;
}

</style>
